/* global localData */
const newsletterSignup = document.querySelector('.link--sign-up-newsletter, .footer-main__newsletter-send .link');
if (newsletterSignup) {
  // eslint-disable-next-line no-unused-vars
  newsletterSignup.addEventListener('click', (event) => {
    const email = document.getElementById('email').value.trim();
    if (email.search(/^[\w\d\._\-]+@[\w\d\-_\.]+\.[\d\w][\d\w]+$/) > -1) {
      document.querySelector('.loading').classList.add('is-active');
      const request = new XMLHttpRequest();
      request.open('POST', localData.siteURL, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      request.send(`action=sendToMailchimp&email=${encodeURI(email)}`);
      request.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          document.querySelectorAll('.result_box').forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.hidden = true;
          });
          const response = JSON.parse(this.responseText);
          if (response.status === 200) {
            document.querySelector('.success_box').hidden = false;
            const button = document.querySelector('.link--sign-up-newsletter');
            if (button) {
              button.style.visibility = 'hidden';
            }
            const buttonSecond = document.querySelector('.link.link--line');
            if (buttonSecond) {
              buttonSecond.style.visibility = 'hidden';
            }
          } else if (response.status === 409) {
            document.querySelector('.already_in_box').hidden = false;
          } else {
            document.querySelector('.error_box').hidden = false;
          }
        }
        document.querySelector('.loading').classList.remove('is-active');
      };
    }
  });
}
